import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'
import { showCurrencyFormat } from '../../../../utils';
import { displayDateFormat, backendDateFormat, fieldDateFormat } from '../../../../constants';
import NumericLabel from 'react-pretty-numbers';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { regexConstants } from '../../../../constants/regEx';
import { gaTelesisInstance, titanInstance } from '../../../../shared_elements/components';

export default class PenaltyDebitNote extends Component{
  constructor(props){
    super(props)
  }
  render(){
    const { type, invoiceInfo, invoice_item, index, error, showJCT } = this.props
    if(type === 'view'){
      return(
        <tr>
          <td>
            <h6 className="para-ui">
            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
             {invoiceInfo.parent_amount}
              </NumericLabel>
            </h6>
          </td>
          {titanInstance && invoiceInfo.is_reserve_releted  ?
            <td className="para-ui">
              {invoice_item?.fh_fc_ration || '--'}
            </td> : null}
          {!titanInstance ?  
          <td className="invoice-penalty-description-block" style={{width:gaTelesisInstance?'330px':''}}>
            <h6 className="para-ui"> {invoiceInfo.description }</h6>
          </td>:null}
          {gaTelesisInstance?
          <td style={{width:gaTelesisInstance?'120px':''}}>
          <h6 className="para-ui">{invoiceInfo.additional_rate ? invoiceInfo.additional_rate : '0'}%</h6>
          </td>:null}
          {gaTelesisInstance?
            <td className="para-ui" style={{width:gaTelesisInstance?'120px':''}}>
            <h6 className="para-ui"> {invoice_item.sofr_percentage ? invoice_item.sofr_percentage:'0' }%</h6>
          </td>
          :null}
          <td className="invoice-date-block">
            <h6 className="para-ui"> {invoiceInfo.penalty_due_date ? moment(invoiceInfo.penalty_due_date).format(displayDateFormat):'--' }</h6>
          </td>
          <td className="invoice-date-block">
            <h6 className="para-ui"> {invoiceInfo.parent_paid_date ? moment(invoiceInfo.parent_paid_date).format(displayDateFormat):'--' }</h6>
          </td>
          <td style={{width:gaTelesisInstance?'130px':''}}>
            <h6 className="para-ui">
              {moment(invoiceInfo.parent_paid_date).diff(moment(invoiceInfo.penalty_due_date),'days')>0 ? moment(invoiceInfo.parent_paid_date).diff(moment(invoiceInfo.penalty_due_date),'days'):'0'}
            </h6>
          </td>
          {!gaTelesisInstance?
          <td className="invoice-usd-day">
            <h6 className="para-ui">{invoiceInfo.libor_value ? invoiceInfo.libor_value : '0'}%</h6>
          </td>:null}
          {!gaTelesisInstance?
          <td>
          <h6 className="para-ui">{invoiceInfo.additional_rate ? invoiceInfo.additional_rate : '0'}%</h6>
          </td>:null}
          {!gaTelesisInstance?
          <td>
            <h6 className="para-ui"> {invoiceInfo.penalty_interest_rate ? invoiceInfo.penalty_interest_rate:'0'}%</h6>
          </td>:null}
          <td style={{minWidth:gaTelesisInstance?'130px':''}}>
            <h6 className="para-ui">
                <div style={{ display: 'flex', alignItems: 'center',justifyContent:'flex-end', gap: 4 }}>
                  <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                     {invoiceInfo.total_amount ? invoiceInfo.total_amount : 0}
                  </NumericLabel>
                  {invoice_item?.excess_amount > 0 ?
                    <Tooltip title={`Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${invoice_item.excess_amount}`}>
                      <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                    </Tooltip> : null}
                </div>
            </h6>
          </td>
          {/* {showJCT ? <>
            <td>
              <h6 className="para-ui"> 10% </h6>
            </td>
            <td>
              <h6 className="para-ui">
                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                  {invoiceInfo.total_amount ? invoiceInfo.total_amount / 10 : 0}
                </NumericLabel>
              </h6>
            </td>
          </> : null} */}
        </tr>
      )
    }else{
      return(
        <tr>
          <td className="invoice-type-block">
          <h6 className="para-ui">
              <NumericLabel params={showCurrencyFormat()}>
                {invoiceInfo.parent_amount}
              </NumericLabel>
            </h6>
          </td>
          {titanInstance && invoiceInfo.is_reserve_releted  ?
            <td className="para-ui">
              {invoice_item?.fh_fc_ration || '--'}
            </td> : null}
          {!titanInstance ?
          <td className="invoice-penalty-description-block" style={{width:gaTelesisInstance?'330px':''}}>
            <input type="text"  value={invoiceInfo.description}
              onChange={(e) => this.props.updateInvoiceField(e.target.value, 'description')}
            />
          </td>:null}
          {gaTelesisInstance?
          <td style={{width:'100px'}}>
            <input type="text"  value={invoiceInfo.additional_rate? invoiceInfo.additional_rate:''}
              onChange={(e) => this.props.updateInvoicePenaltyField(e.target.value, 'additional_rate')}
            />
            <h6 className="error-msg">{error.additional_rate}</h6>
          </td>:null}
          {gaTelesisInstance?
          <td style={{width:'100px'}}>
            <input type='text' value ={invoice_item?.sofr_percentage || ''}
            onChange={(e)=> regexConstants.numberWithDot.test(e.target.value) ? e.target.value > 100 ? e.preventDefault() : 
              this.props.updateInvoicePenaltyField(e.target.value, 'sofr_percentage'): e.preventDefault()}
            />
          </td>:null}
          <td className="invoice-date-block" style={{width:gaTelesisInstance?'120px':''}}>
            <DatePicker
            dateFormat = {fieldDateFormat}
            selected={invoiceInfo.penalty_due_date && moment(invoiceInfo.penalty_due_date).isValid() ? moment(invoiceInfo.penalty_due_date) : null}
            onChange={(e) => {this.props.updateInvoicePenaltyField(moment(e).format(backendDateFormat), 'penalty_due_date');this.props.updateInvoicePenaltyField(moment(invoiceInfo.parent_paid_date).diff(moment(e),'days')>0 ? moment(invoiceInfo.parent_paid_date).diff(moment(e),'days'):0 , 'over_due_days')}}
          //  maxDate={moment(moment(invoiceInfo.end_date).format('YYYY') + '-' + moment(invoiceInfo.end_date).format('MM')+'-'+ moment(invoiceInfo.end_date).format('DD')).subtract(1, "days")}
            showYearDropdown
            showMonthDropdown
            useShortMonthInDropdown
            onBlur={() => this.props.dateValidation(invoiceInfo.parent_paid_date ,invoiceInfo.penalty_due_date, 'penalty_due_date')}
            onFocus = {() => this.props.validationClear('penalty_due_date')}

         />
         <h6 className="error-msg">{error.penalty_due_date}</h6>


          </td>
          <td className="invoice-date-block" style={{width:gaTelesisInstance?'120px':''}}>

            <DatePicker
            dateFormat = {fieldDateFormat}
            selected={invoiceInfo.parent_paid_date && moment(invoiceInfo.parent_paid_date).isValid() ? moment(invoiceInfo.parent_paid_date) : moment() }
            onChange={(e) => {this.props.updateInvoicePenaltyField(moment(e).format(backendDateFormat), 'parent_paid_date');this.props.updateInvoicePenaltyField(moment(e).diff(moment(invoiceInfo.penalty_due_date),'days')>0 ? moment(e).diff(moment(invoiceInfo.penalty_due_date),'days'):0 , 'over_due_days')}}
           // minDate={moment(moment(invoiceInfo.due_date).format('YYYY') + '-' + moment(invoiceInfo.due_date).format('MM') + '-'+ moment(invoiceInfo.due_date).format('DD')).add(1, "days")}
            showYearDropdown
            showMonthDropdown
            useShortMonthInDropdown
            onBlur={() => this.props.dateValidation(invoiceInfo.parent_paid_date, invoiceInfo.penalty_due_date, 'parent_paid_date')}
            onFocus = {() => this.props.validationClear('parent_paid_date')}

          />
          <h6 className="error-msg">{error.parent_paid_date}</h6>

          </td>
          <td className="invoice-overdue-day"style={{width:gaTelesisInstance?'120px':''}} >
          <h6 className="para-ui">{invoiceInfo.over_due_days ? invoiceInfo.over_due_days:moment(invoiceInfo.parent_paid_date).diff(moment(invoiceInfo.penalty_due_date),'days')>0 ? moment(invoiceInfo.parent_paid_date).diff(moment(invoiceInfo.penalty_due_date),'days'):0}</h6>
          </td>
          {!gaTelesisInstance ?
          <td className="invoice-usd-day">
            <input type="text"  value={invoiceInfo.libor_value ? invoiceInfo.libor_value:''}
            onChange={(e) => this.props.updateInvoicePenaltyField(e.target.value, 'libor_value')}
            />
             <h6 className="error-msg">{error.libor_value}</h6>
          </td>:null}
          {!gaTelesisInstance ?
          <td>
            <input type="text"  value={invoiceInfo.additional_rate? invoiceInfo.additional_rate:''}
              onChange={(e) => this.props.updateInvoicePenaltyField(e.target.value, 'additional_rate')}
            />
            <h6 className="error-msg">{error.additional_rate}</h6>
          </td>:null}
          {!gaTelesisInstance?
          <td>
            <h6 className="para-ui"> {invoiceInfo.penalty_interest_rate ? invoiceInfo.penalty_interest_rate:'0'}% </h6>
          </td>:null}
          <td>
          <h6 className="para-ui" style={{minWidth:gaTelesisInstance?'100px':''}}>
              <NumericLabel params={showCurrencyFormat()}>
                {invoiceInfo.total_amount}
              </NumericLabel>
          </h6>
          </td>
          {/* {showJCT ? <>
            <td>
              <h6 className="para-ui"> 10% </h6>
            </td>
            <td>
              <h6 className="para-ui">
                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                  {invoiceInfo.total_amount ? invoiceInfo.total_amount / 10 : 0}
                </NumericLabel>
              </h6>
            </td>
          </> : null} */}
        </tr>
      )
    }
  }
}
